import CheckboxGroup from './checkbox-group'
export default CheckboxGroup
